import { Component,OnInit } from '@angular/core';
import { ActivatedRoute, Params,Router } from '@angular/router';
import { ViajesService } from './../../../services/viajes.service';
import { UnidadesService } from './../../../services/unidades.service';
import { Observable } from 'rxjs/Observable';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { CSVService } from 'app/services/csv.service';

@Component({
    selector: 'viajes-terminados',
	templateUrl : './viaje-terminado.component.html'
})

export class viajeTerminadoComponent  implements OnInit{
    listaViajes: any = []; // Lista de viajes obtenidos
fechaInicial: string = this.formatDateToInputValue(new Date());
fechaFinal: string = this.formatDateToInputValue(new Date());
today: string;

    constructor(
        private viajesService:ViajesService,
        private csvService:CSVService
    ){}
    ngOnInit(){
         this.today = this.formatDateToInputValue(new Date());

  if (!this.fechaInicial) {
    this.fechaInicial = '2025-07-11';
  }
  if (!this.fechaFinal) {
    this.fechaFinal = this.today;
  }

  this.obtenerViajesConcluidosEntreFechas();
    }

    private formatDateToInputValue(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
  const day = (date.getDate() < 10 ? '0' : '') + date.getDate();
  return `${year}-${month}-${day}`;
}

    getDuracioneEnDiasHorasMinutos(duracion: number): string {
        const dias = Math.floor(duracion / (24 * 60 * 60));
        const horas = Math.floor((duracion % (24 * 60 * 60)) / (60 * 60));
        const minutos = Math.floor((duracion % (60 * 60)) / 60
        );
        //return only if greater than 0
        let resultado = '';
        if (dias > 0) {
            resultado += `${dias} día${dias > 1 ? 's' : ''} `;
        }
        if (horas > 0) {
            resultado += `${horas} hora${horas > 1 ? 's' : ''} `;
        }
        if (minutos > 0) {
            resultado += `${minutos} minuto${minutos > 1 ? 's' : ''}`;
        }

        return resultado.trim();
    }
    
   safelyParseJsonWithFallback(jsonString: string, key: string): string {
  try {
    const parsed = JSON.parse(jsonString);
    if (parsed && typeof parsed === 'object' && parsed[key]) {
      return parsed[key];
    }
  } catch (e) {
    console.warn(`JSON parse failed for key "${key}", attempting regex fallback.`, jsonString);
    
    // Fallback: try to extract the value of the key manually with a regex
    const regex = new RegExp(`"${key}"\\s*:\\s*"([^"]+)"`);
    const match = jsonString.match(regex);
    if (match && match[1]) {
      return match[1];
    }
  }

  return '';
}

    extractConceptosAdicionalesAsArray(jsonString: string): any[] {
      try {
        const parsed = JSON.parse(jsonString);
        if(!parsed || typeof parsed !== 'object') {
          console.warn('Parsed conceptosAdicionales is not an object or is empty.', jsonString);
          return [];
        }
        const conceptosObj = parsed.conceptosAdicionales;

        if (conceptosObj && typeof conceptosObj === 'object') {
          // Convert the object to an array of values (you can also keep the keys if needed)
          return Object.keys(conceptosObj).map((key) => (conceptosObj[key].nombre + " - $" + conceptosObj[key].precio));
        }
      } catch (e) {
        console.warn('JSON parse failed for conceptosAdicionales fallback.', jsonString);

        // Optional: fallback regex extraction (not ideal for nested objects, but possible for debug)
        // You can skip this unless you really need a last-resort strategy
      }

      return []; // Return empty array if not found or malformed
    }



    public obtenerViajesConcluidosEntreFechas(){
        this.viajesService.getHistoricoViajesEntreFechas(this.fechaInicial,this.fechaFinal).take(1).subscribe(res => {
            console.log("Viajes obtenidos", res);
            this.listaViajes = res.map((viaje: any) => {
              const conceptosArray = this.extractConceptosAdicionalesAsArray(viaje.info_ruta.info_adicional);
            return {
                idTrosten: viaje.info_ruta.idTrosten,
                horaInicio: viaje.info_ruta.horaInicio,
                horaFin: viaje.info_ruta.horaFin,
                origen: this.safelyParseJsonWithFallback(viaje.info_ruta.origen, 'alias'),
                destino: this.safelyParseJsonWithFallback(viaje.info_ruta.destino, 'alias'),
                operador: this.safelyParseJsonWithFallback(viaje.operador, 'nombre'),
                unidad: this.safelyParseJsonWithFallback(viaje.unidad, 'clave'),
                tipoDeViaje: viaje.info_ruta.tipoDeViaje,
                duracion: this.getDuracioneEnDiasHorasMinutos((viaje.info_ruta.horaFin - viaje.info_ruta.horaInicio) / 1000),
                otrosGastos: conceptosArray.join(', '),
                oficina: viaje.info_ruta.zona,
                horasCotizadas: viaje.info_ruta.horasCotizadas
            };
            });
            this.sortListaGeneralPagos();
        });
    }
   


    sortField: string = 'horaInicio';
    sortAsc: boolean = true;

    setSort(field: string) {
  if (this.sortField === field) {
    this.sortAsc = !this.sortAsc;
  } else {
    this.sortField = field;
    this.sortAsc = true;
  }
  this.sortListaGeneralPagos();
    }

    sortListaGeneralPagos() {
    this.listaViajes.sort((a, b) => {
        const valA = this.resolvePath(a, this.sortField);
        const valB = this.resolvePath(b, this.sortField);

        if (valA == null) return 1;
        if (valB == null) return -1;
        if (valA === valB) return 0;

        return this.sortAsc
        ? valA > valB ? 1 : -1
        : valA < valB ? 1 : -1;
    });
    }

    // Helper to resolve nested props like "infoServicio.inicioDeServicio"
    resolvePath(obj: any, path: string) {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    }

    descargarCSV() {
        this.csvService.descargarReporteDeViajesConcluidos(this.listaViajes);
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/viajes-terminados/viaje-terminado.component.ts